<template>
    <div class="mx-2 flex flex-col gap-1 py-2" v-cloak>

        <div v-if="fetching" class="my-1 flex items-center justify-center gap-2">
            <span class="text-sm text-gray-100">Fetching...</span>
            <spinner />
        </div>

        <div v-if="!fetching" class="flex flex-col gap-1">

            <div class="uppercase text-xs text-center font-semibold mb-2">Blockchain</div>
            <ul class="mb-2 flex flex-col gap-1">
                <li v-for="(item, index) in blockchain" class="flex flex-col mx-2 py-1 px-2 rounded text-sm"
                    :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'">
                    <div class="flex items-center justify-between">
                        <div>{{ item.label }}</div>
                        <div class="flex items-center gap-1">
                            <div>{{ item.value }}</div>
                            <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                        </div>
                    </div>
                </li>
            </ul>

            <div class="uppercase text-xs text-center font-semibold">Tokens</div>
            <ul class="mb-2 flex flex-col gap-1">
                <li v-for="(item, index) in tokensBalance" class="flex flex-col mx-2 py-1 px-2 rounded text-sm"
                    :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'">
                    <div class="flex items-center justify-between">
                        <div>{{ item.label }}</div>
                        <div class="flex items-center gap-1">
                            <div>{{ item.value }}</div>
                            <img :src="rrToken(item.slug).image" class="block h-4 w-4 rounded-full" />
                        </div>
                    </div>
                </li>
            </ul>

            <div class="uppercase text-xs text-center font-semibold">Database</div>
            <ul class="mb-2 flex flex-col gap-1">
                <li v-for="(item, index) in database" class="flex flex-col mx-2 py-1 px-2 rounded text-sm"
                    :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'">
                    <div class="flex items-center justify-between">
                        <div>{{ item.label }}</div>
                        <div class="flex items-center gap-1">
                            <div>{{ item.value }}</div>
                            <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                        </div>
                    </div>
                </li>
            </ul>

        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'AdminSubPanelBalances',
    props: ['token', 'tokens'],
    data() {
        return {
            fetching: false,
            blockchain: [],
            tokensBalance: [],
            database: [],
        }
    },
    mounted() {
        this.fetching = true
        axios.get('/api/admin/balances', {
            headers: {
                'Authorization': `Bearer ${this.token}`
            }
        }).then((response) => {
            this.blockchain = response.data.data.blockchain
            this.tokensBalance = response.data.data.tokens
            this.database = response.data.data.database
        }).catch(() => {
            this.$toast.error('Error fetching Balances.')
        }).finally(() => {
            this.fetching = false
        })
    },
    methods: {
        rrToken(slug) {
            return this.tokens.find(item => item.slug === slug)
        },
    },
}
</script>
